<template>
  <div class="search-bar">
    <div class="section">
      <div class="section-wrap">
        <div class="main">
          <!-- <h1 class="title">
          <span class="logo"></span>
          <span>{{ $t('title') }}</span>
        </h1> -->
          <div class="app-search">
            <form @submit="formSubmit">
              <div class="input-with-btn">
                <span class="input-with-btn--ipt-wrap">
                  <input v-model="searchContent" type="text" class="input-with-btn--ipt" placeholder="Search for City, Neighborhood, Zip, County, School" />
                </span>
                <button class="input-with-btn--btn" @click="search">{{ $t('Search') }}</button>
              </div>
            </form>
            <span class="clear" v-if="searchContent" @click="clearSearch">Clear search</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    defaultContent: String,
  },
  data() {
    return {
      searchContent: this.defaultContent || '',
    }
  },
  methods: {
    search() {
      this.$emit('search', this.searchContent)
    },
    formSubmit(e) {
      e.preventDefault()
    },
    clearSearch(text) {
      this.searchContent = ''
      this.search()
    }
  },
}

</script>
